import { render, staticRenderFns } from "./SystemEditForm.vue?vue&type=template&id=40fda21d&"
import script from "./SystemEditForm.vue?vue&type=script&lang=js&"
export * from "./SystemEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports